import { action, observable } from "mobx";
import type { PageFragment } from "../../app/core/generated/webapi.g";

export interface IPage {
    currentPage: PageFragment | null;
    notFoundPage?: PageFragment;
}

export interface HiddenPageBlocks {
    header: boolean;
    headerAd: boolean;
}

export class Page {
    private setTagsSet() {
        this.tagsSet = new Set();
        // this optional chaining on tags isn't really needed
        // only added so I don't have to track down every single test fixture
        this.currentPage?.tags?.forEach(hint => this.tagsSet.add(hint.id));
    }

    @observable
    currentPage: PageFragment | null = null;

    @observable
    notFoundPage?: PageFragment;

    @observable
    statusCode? = 200;

    @observable
    tagsSet: Set<string> = new Set();

    constructor({ currentPage, notFoundPage }: IPage) {
        if (currentPage) {
            this.currentPage = currentPage;
            this.setTagsSet();
        }

        if (notFoundPage) {
            this.notFoundPage = notFoundPage;
        }
    }

    @action
    storePage = (page: PageFragment | null) => {
        this.currentPage = page;
        this.setTagsSet();
    };

    @action
    storeStatus = (statusCode: number) => (this.statusCode = statusCode);

    @action
    storeNotFoundPage = (page: PageFragment) => (this.notFoundPage = page);
}
